import React from 'react';
import { Link } from '@mui/material';

const ComButton = ({ href, dataTestid, children, onClick, disabled = false }) => {

  const handleClick = event => {
    if (disabled) {
      event.preventDefault();
    } else {
      onClick();
    }
  }

  return (
    <Link
      className="com-button"
      href={!disabled ? href: undefined}
      onClick={(event) => handleClick(event)}
      aria-disabled={disabled}
      disabled={disabled}
      data-testid={dataTestid}
    >
      {children}
  </Link>
  );
};

export { ComButton };
